import React from 'react'

export default function Stats({appData}) {
  return (
    <div>Stats

      {JSON.stringify(appData)}
    </div>
  )
}
